import React, { useMemo, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { Link, useNavigate } from 'react-router-dom';
import { Header, Footer } from './headerFooter';
import {
    getDonationReturnPath,
    clearDonationReturnPath,
    consumeDonationPremiumGranted,
} from './donationReturnPath';
import { getLastDonation, trackDonationComplete } from './analytics';
import { PREMIUM_ACCESS_UNTIL_LABEL } from './constants';
import './custom.scss';

function DonationSuccess() {
    const navigate = useNavigate();
    const premiumGranted = useMemo(() => consumeDonationPremiumGranted(), []);
    const continuePath = useMemo(() => getDonationReturnPath('/predict'), []);

    useEffect(() => {
        const last = getLastDonation();
        if (last?.transaction_id) {
            trackDonationComplete({
                transactionId: last.transaction_id,
                premiumGranted: last.premium_granted ?? premiumGranted,
                donationSource: last.donation_source,
            });
        }
    }, [premiumGranted]);

    const goContinue = () => {
        clearDonationReturnPath();
        navigate(continuePath, { replace: true });
    };

    return (
        <div id="root">
            <Header />
            <main className="main-container">
                <Container className="custom-container pt-4 pb-4">
                    <h2 className="mb-3">Ευχαριστούμε πολύ για τη στήριξή σας</h2>

                    {premiumGranted ? (
                        <>
                            <Alert variant="success" className="mb-3">
                                Η δωρεά σας ολοκληρώθηκε με επιτυχία και η πρόσβαση{' '}
                                <strong>premium</strong> στο εργαλείο προβλέψεων ενεργοποιήθηκε και ισχύει μέχρι τις{' '}
                                <strong>{PREMIUM_ACCESS_UNTIL_LABEL}</strong>.
                            </Alert>
                            <p className="mb-4">
                                Μπορείτε να συνεχίσετε τη δουλειά σας στο εργαλείο{' '}
                                <strong>Εκτιμήσεις πιθανοτήτων πρόσληψης</strong>.
                            </p>
                            <div className="d-flex flex-wrap gap-2">
                                <Button variant="primary" onClick={goContinue}>
                                    Συνέχεια στο εργαλείο προβλέψεων
                                </Button>
                                <Button as={Link} to="/main" variant="outline-secondary">
                                    Επιστροφή στα εργαλεία
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="mb-4">
                                Η υποστήριξή σας βοηθά να συνεχίσουμε την προσπάθειά μας για το teachers-app.com.
                            </p>
                            <div className="d-flex flex-wrap gap-2">
                                <Button variant="primary" onClick={goContinue}>
                                    Συνέχεια στο εργαλείο προβλέψεων
                                </Button>
                                <Button as={Link} to="/main" variant="outline-secondary">
                                    Επιστροφή στα εργαλεία
                                </Button>
                            </div>
                        </>
                    )}
                </Container>
            </main>
            <Footer />
        </div>
    );
}

export default DonationSuccess;
